import React from "react"

import { Section, Wrapper, Header, Grid, Item } from "./styles/index.styled"

const StatsComponent = ({ component }) => {
  if (!component) return null
  const { heading, subhead, stats } = component

  return (
    <Section>
      <Wrapper>
        {heading || subhead ? (
          <Header>
            {heading && <h2 className="heading">{heading}</h2>}
            {subhead && (
              <div
                className="subhead"
                dangerouslySetInnerHTML={{ __html: subhead }}
              />
            )}
          </Header>
        ) : null}
        {stats && stats?.length > 0 ? (
          <Grid>
            {stats?.map((stat) => (
              <Item key={stat?.id}>
                <h2 className="heading">{stat?.heading}</h2>
                <p className="subhead">{stat?.subhead}</p>
              </Item>
            ))}
          </Grid>
        ) : null}
      </Wrapper>
    </Section>
  )
}

export default StatsComponent
